// Purpose-specific, tab-scoped proof. Never put it in a query, analytics or Pinia.
const KEY = 'miinta_school_registration'
const TOKEN = /^[A-Za-z0-9_-]{43}$/
const ENTRY = /^\/signup\/([0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i
const TTL = 30 * 60 * 1000
type Pending = { entrypointId: string; token: string; capturedAt: number }
let pending: Pending | null = null

export function clearSchoolRegistrationToken(): void {
  pending = null
  try {
    window.sessionStorage.removeItem(KEY)
  } catch {
    /* storage may be disabled */
  }
}

export function peekSchoolRegistrationToken(entrypointId: string): string | null {
  try {
    pending ??= JSON.parse(window.sessionStorage.getItem(KEY) ?? 'null')
  } catch {
    clearSchoolRegistrationToken()
  }
  if (
    !pending ||
    !TOKEN.test(pending.token) ||
    !Number.isFinite(pending.capturedAt) ||
    Date.now() < pending.capturedAt ||
    Date.now() - pending.capturedAt >= TTL
  ) {
    clearSchoolRegistrationToken()
    return null
  }
  return pending.entrypointId === entrypointId ? pending.token : null
}

// Returns a sanitized URL for native routing; initial capture happens before telemetry.
export function captureSchoolRegistrationTokenFromUrl(value = window.location.href): string {
  const url = new URL(value)
  const fragment = new URLSearchParams(url.hash.slice(1))
  if (!fragment.has('schoolRegistrationToken')) return url.href
  const token = fragment.get('schoolRegistrationToken') ?? ''
  const entrypointId = ENTRY.exec(url.pathname)?.[1]
  clearSchoolRegistrationToken()
  const trusted =
    url.origin === window.location.origin ||
    (url.protocol === 'https:' &&
      !url.username &&
      !url.password &&
      (url.hostname === 'hellomiinta.com' || url.hostname.endsWith('.hellomiinta.com')))
  if (trusted && entrypointId && TOKEN.test(token)) {
    pending = { entrypointId, token, capturedAt: Date.now() }
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify(pending))
    } catch {
      /* in-memory fallback */
    }
  }
  fragment.delete('schoolRegistrationToken')
  url.hash = fragment.toString()
  if (value === window.location.href) {
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
  }
  return url.href
}
